import { useSkaldElements } from '@skaldaura/devkit'
import { ReactNode, useEffect } from 'react'
import './scrollSection.scss'

interface IProps {
   zoneName: string
   topInsertedElements?: ReactNode[]
   firstIsLoaded?: () => void
}

export default function ScrollSection({ zoneName, topInsertedElements, firstIsLoaded }: IProps) {
   const [elements, fetchingOver] = useSkaldElements(zoneName)
   useEffect(() => {
      if (fetchingOver && firstIsLoaded) {
         firstIsLoaded()
      }
   }, [fetchingOver])
   return (
      <div id={`${zoneName.replaceAll(' ', '_')}`} className='scroll-section'>
         <div>{topInsertedElements && [topInsertedElements]}</div>

         {elements.length > 0 ? (
            elements.map((element) => {
               return (
                  <img
                     key={element.elementid}
                     src={element.value}
                     className='scroll-section-content'
                  />
               )
            })
         ) : (
            <div className=' scroll-section-content h-full w-full relative min-h-[200px] '>
               <div className='image-loading'>
                  <div className='spinner'></div>
               </div>
            </div>
         )}
      </div>
   )
}
